import { Action, Dispatch } from 'redux'
import { State } from 'index'
import { initCheckoutUnsubscribeAction } from 'reducks/checkout/actions'

const unsubscribeOrders = () => {
  return async (dispatch: Dispatch<Action>, getState: () => State) => {
    const unsubscribes = getState().checkout.unsubscribes
    unsubscribes.map((unsubscribe: () => void) => unsubscribe())
    dispatch(initCheckoutUnsubscribeAction())
  }
}

export default unsubscribeOrders
